// Mobx
import { Store, VueStore, Watch } from "@mgs/ci2019-common/src/store";
// Api
import { Api } from "#/api";
// Models
import { BodyBuilder } from "#/common/interfaces/conversionworld/BodyBuilder";
import { Branche } from "../../common/interfaces/conversionworld/Branche";
import { Product } from "#/common/interfaces/conversionworld/Product";
import { Store as AppStore } from "../index";

interface FilterTag {
  category: string;
  object: object;
}

@Store
export class ConverionWorldState extends VueStore {
  public KEY_LOCALSTORAGE_PRODUCTS = "cw-product-comparison";

  public branchen: Branche[] = [];
  public branchenAreLoading: boolean = false;

  public bodyBuilder: BodyBuilder | null = null;

  public vanPartnerBodybuilderTotalCount: number = 0;

  public vanSolutionBodybuilderTotalCount: number = 0;

  public vanPartnerProductsTotalCount: number = 0;

  public vanSolutionProductsTotalCount: number = 0;

  public compareProducts: Product[] = [];

  public filterModuleFixed: boolean = false;

  created() {
    var products = window.localStorage.getItem(this.KEY_LOCALSTORAGE_PRODUCTS);
    if (products) {
      this.compareProducts = JSON.parse(products);
    }
  }

  @Watch("compareProducts")
  public onCompareProductsChange() {
    window.localStorage.setItem(
      this.KEY_LOCALSTORAGE_PRODUCTS,
      JSON.stringify(this.compareProducts)
    );
  }

  get bodybuilderCount() {
    if (AppStore.instance.conversionWorldProductFilter.filterData) {
      return AppStore.instance.conversionWorldProductFilter.filterData
        .bodybuilder_count;
    }

    return (
      this.vanPartnerBodybuilderTotalCount +
      this.vanSolutionBodybuilderTotalCount
    );
  }

  get productCount() {
    if (AppStore.instance.conversionWorldProductFilter.filterData) {
      return AppStore.instance.conversionWorldProductFilter.filterData.count;
    }

    return (
      this.vanPartnerProductsTotalCount + this.vanSolutionProductsTotalCount
    );
  }

  public async getBodyBuilder(abhid, pageId): Promise<BodyBuilder> {
    this.bodyBuilder = await Api.conversionWorldService.getBodyBuilder(
      abhid,
      pageId
    );
    return this.bodyBuilder;
  }

  public async loadBranchen(pageId: number) {
    if (this.branchenAreLoading) {
      return;
    }

    this.forceLoadBranchen(pageId);
  }

  public async forceLoadBranchen(pageId: number) {
    this.branchenAreLoading = true;
    this.branchen = await Api.conversionWorldService.getBranchen(pageId);
  }

  get bodyBuilderType() {
    return this.bodyBuilder ? this.bodyBuilder.type : null;
  }

  get bodyBuilderProducts() {
    return this.bodyBuilder ? this.bodyBuilder.products : [];
  }

  get bodyBuilderReports() {
    return this.bodyBuilder ? this.bodyBuilder.reports : [];
  }

  get hasCertificate() {
    return this.bodyBuilder && this.bodyBuilder.certificate;
  }

  get isVanSolution() {
    if (this.bodyBuilder) {
      return this.bodyBuilder.type == "vansolution";
    } else {
      return false;
    }
  }

  get certificateMediumImage() {
    return this.bodyBuilder ? this.bodyBuilder.certificate.medium : null;
  }

  get certificateLargeImage() {
    return this.bodyBuilder ? this.bodyBuilder.certificate.xlarge : null;
  }

  public removeCompareProduct(id) {
    let index = this.compareProducts.findIndex((i) => i.id == id);
    this.compareProducts.splice(index, 1);
  }

  public setCompareProduct(product: Product, value: boolean) {
    if (value) {
      this.compareProducts.push(product);
    } else {
      this.removeCompareProduct(product.id);
    }
  }

  public isCompareProduct(id) {
    return this.compareProducts.find((x) => x.id == id) != undefined;
  }

  public removeAllCompareProducts() {
    this.compareProducts = [];
  }
}
